export default __webpack_public_path__ + "static/media/1885.e8d86cf2.png";